// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangePasswordForm_wrapper__BvmPt","tip":"ChangePasswordForm_tip__N_4Mx","success":"ChangePasswordForm_success___KRmS"};